import { Flex, FlexProps, Text } from '@chakra-ui/react';

const RatingPill = ({ rating, ...flexProps }: { rating: number } & FlexProps) => (
  <Flex
    align="center"
    gap={2}
    display="inline-flex"
    bg="iceBlue"
    borderRadius="full"
    px={3.5}
    py={1.5}
    {...flexProps}
  >
    <Text fontSize="13px" fontWeight={600} color="leaseEndGray">
      You rated it
    </Text>
    <Text fontWeight={700} fontSize="16px" color="leaseEndBlue">
      {rating}/10
    </Text>
  </Flex>
);

export default RatingPill;
